import { useState } from 'react';

const faqs = [
	{
		q: 'What services does Viance Healthcare Systems provide?',
		a: 'We provide mobile app development, website development, database management, and cloud/devops support.',
	},
	{
		q: 'Do you build custom software?',
		a: 'Yes. Every project is scoped and built around your business process, users, and delivery goals.',
	},
	{
		q: 'Can you work with existing systems?',
		a: 'Yes. We can modernize existing products, improve performance, and integrate new modules without full rewrites.',
	},
	{
		q: 'Where is your company located?',
		a: 'Sulochana Apartments, Income Tax Lane, Pune - 411004.',
	},
		{
		q: 'How can we start a project?',
		a: 'Use the contact form and share your requirement. Our team will respond with the next steps and estimated timeline.',
	},
];

function FAQ() {
	const [openIndex, setOpenIndex] = useState(0);

	return (
		<section id="faq" className="rounded-3xl bg-white px-5 py-12 shadow-sm ring-1 ring-slate-200 sm:px-7 lg:px-8">
			<div className="mx-auto max-w-3xl text-center">
				<h2 className="text-3xl font-bold text-slate-900 sm:text-4xl">Frequently Asked Questions</h2>
				<p className="mt-3 text-base text-slate-600 sm:text-lg">
					If you don&apos;t see your question here, reach out and our team will respond quickly.
				</p>
			</div>

			<div className="mx-auto mt-8 max-w-5xl space-y-3">
				{faqs.map((item, index) => {
					const isOpen = openIndex === index;
					return (
						<div key={item.q} className="rounded-2xl border border-slate-200 bg-slate-50">
							<button
								type="button"
								onClick={() => setOpenIndex(isOpen ? -1 : index)}
								className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
							>
								<span className="text-xl font-semibold text-slate-800">{item.q}</span>
								<span className="text-2xl text-slate-500">{isOpen ? '−' : '+'}</span>
							</button>
							{isOpen && <p className="px-5 pb-4 text-lg text-slate-600">{item.a}</p>}
						</div>
					);
				})}
			</div>
		</section>
	);
}

export default FAQ;
